import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, XCircle } from 'lucide-react';
export function Audience() {
  return <section className="py-20 bg-dark" data-id="element-7">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-8">
        {/* Who is this for / not for */}
        <div className="grid md:grid-cols-2 gap-8 mb-24" data-id="element-9">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-dark-lighter p-8 rounded-2xl border-t-4 border-green-500" data-id="element-10">
            <h3 className="text-3xl font-bold mb-8 text-white" data-id="element-11">
              ESTO ES PARA TI SI...
            </h3>
            <ul className="space-y-6" data-id="element-12">
              {['Hombres de 45+ que aman el ritual del asado semanal.', 'Hombres que sufren de gota, artritis o rigidez matutina persistente.', 'Aquellos que no están dispuestos a volverse vegetarianos para estar sanos.', 'Padres y abuelos que quieren energía para jugar con su familia tras la comida.'].map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-13">
                  <CheckCircle className="w-6 h-6 text-green-500 shrink-0 mt-1" data-id="element-14" />
                  <span className="text-lg text-offwhite/90" data-id="element-15">{text}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-dark-lighter p-8 rounded-2xl border-t-4 border-danger" data-id="element-16">
            <h3 className="text-3xl font-bold mb-8 text-white" data-id="element-17">
              NO ES PARA TI SI...
            </h3>
            <ul className="space-y-6" data-id="element-18">
              {['Personas que buscan dietas veganas o vegetarianas.', 'Quienes prefieren seguir tomando pastillas antes que cambiar de aceite.', 'Aquellos que no están dispuestos a dedicar 15 minutos a leer una guía.'].map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-19">
                  <XCircle className="w-6 h-6 text-danger shrink-0 mt-1" data-id="element-20" />
                  <span className="text-lg text-offwhite/90" data-id="element-21">{text}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        {/* How It Works */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-22">
          <h2 className="text-4xl md:text-5xl font-bold text-center mb-16" data-id="element-23">
            Cómo Funciona
          </h2>
          <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-24">
            {/* Connecting line for desktop */}
            <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-amber/20 z-0" data-id="element-25"></div>

            {[{
            step: '1',
            text: "Descarga la guía y limpia tu despensa de los 3 'saboteadores' principales."
          }, {
            step: '2',
            text: "Aplica la 'Marinada Escudo' 20 minutos antes de tu próximo asado."
          }, {
            step: '3',
            text: 'Despierta el lunes sintiéndote ligero, ágil y listo para la semana.'
          }].map((item, i) => <div key={i} className="relative z-10 flex flex-col items-center text-center" data-id="element-26">
                <div className="w-24 h-24 rounded-full bg-dark border-4 border-amber flex items-center justify-center text-4xl font-bold text-amber mb-6 shadow-[0_0_20px_rgba(232,130,12,0.3)]" data-id="element-27">
                  {item.step}
                </div>
                <p className="text-xl text-offwhite/90 font-medium px-4" data-id="element-28">
                  {item.text}
                </p>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}